<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><strong>Race, Ethnicity, and Policing</strong></h1>
<p class="subtitle"><em>New and Essential Readings</em></p>
<p class="center"><span class="small">EDITED BY</span></p>
<p class="author"><em>Stephen K. Rice and Michael D. White</em></p>
<p class="centerv"><span class="small">INTRODUCTION BY</span></p>
<p class="centerv"><em>Robin S. Engel</em></p>
<p class="pubimage"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?215e1274